// extracted by mini-css-extract-plugin
export default {"container":"ClaimManagement_container__33lio","title":"ClaimManagement_title__uE-4+"};